// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CenterPinButton__container-f0b3a7 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  position: absolute;
  background-color: var(--addition-50);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  border-radius: 8px;
  bottom: 0;
  inset-inline-end: 10px;
  cursor: pointer;
}

.CenterPinButton__container-f0b3a7 {
  fill: var(--addition-40_60);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SelectLocationPopup/CenterPinButton/CenterPinButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,+CAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,2BAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  background-color: var(--addition-50);\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;\n  border-radius: 8px;\n  bottom: 0;\n  inset-inline-end: 10px;\n  cursor: pointer;\n}\n\n.container {\n  fill: var(--addition-40_60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CenterPinButton__container-f0b3a7`
};
module.exports = ___CSS_LOADER_EXPORT___;
